module.exports = __webpack_public_path__ + "img/DANAL_20220501.10b8d884.png";